import { eventHelpers } from './learningEventsApi';

type TopicSetUpdater = (update: (previous: Set<string>) => Set<string>) => void;

const updateMembership = (
  setTopics: TopicSetUpdater,
  topicId: string,
  completed: boolean
) => {
  setTopics(previous => {
    const next = new Set(previous);
    if (completed) next.add(topicId);
    else next.delete(topicId);
    return next;
  });
};

export const persistTopicCompletion = async ({
  topicId,
  courseId,
  isCompleting,
  setTopics,
  notifyFailure
}: {
  topicId: string;
  courseId?: string;
  isCompleting: boolean;
  setTopics: TopicSetUpdater;
  notifyFailure: () => void;
}): Promise<boolean> => {
  updateMembership(setTopics, topicId, isCompleting);
  try {
    await eventHelpers.logTopicCompletion(topicId, courseId, isCompleting, 0);
    return true;
  } catch {
    setTopics(previous => {
      // Do not undo a newer user choice that completed while this request was
      // in flight; only revert the optimistic value owned by this request.
      if (previous.has(topicId) !== isCompleting) return previous;
      const next = new Set(previous);
      if (isCompleting) next.delete(topicId);
      else next.add(topicId);
      return next;
    });
    notifyFailure();
    return false;
  }
};
